<div class="ai-global-overlay" aria-live="polite" aria-label="Cargando resultados IA">
  <div class="ai-stars-stage" aria-hidden="true">
    <span class="ai-star star-1"></span>
    <span class="ai-star star-2"></span>
    <span class="ai-star star-3"></span>
  </div>
</div>
